import { render } from "./AppUploadButton.vue?vue&type=template&id=1e680f9b&scoped=true"
import script from "./AppUploadButton.vue?vue&type=script&lang=js"
export * from "./AppUploadButton.vue?vue&type=script&lang=js"

import "./AppUploadButton.vue?vue&type=style&index=0&id=1e680f9b&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e680f9b"]])

export default __exports__